<template>
<div>
    <smallbutton :toplabel="titleLabel_short" @click="startAdd()" v-if="showButton" :buttonclass="buttonclass" :disabled="disabled"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">{{ titleLabel }}</label>
                <br/>
                
                
                <formentry   label="Name"  v-model="currentType.name" :isrequired="trueParam" @change="currentType.dirty=true" />
                
           

                <div class="entry" >
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="">Additional Cost</label>
                    </div>
                    <input v-model="currentType.hasAdditionalCost" type="checkbox">
                </div>
                <formentry   label="Cost"  v-model="currentType.price" :isrequired="trueParam" v-if="currentType.hasAdditionalCost"  @change="currentType.dirty=true" />
                <smallbutton  @click="save()" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{message}}</label>
                </div>
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
export default {
    name:'updateoptiontype',
    components:{
        smallbutton,
        actionmodal,
        formentry,
    },
    props:{
        inType:{
            type:Object,
        },
        isAdd:{
            type:Boolean,
            default:false
        },
        typeName:{
            type:String,
            required:true
        },
        showButton:{
            type:Boolean,
            default:false
        },
        buttonclass:{
          type:String,
          default:"button buttonprimary"
        },
        disabled:{
            type:Boolean,
            default:false
        }
        
    },
    mixins:[format],
    data(){
        return{
            
            currentType:{
                id:0,
                name:null,
                isActive:false
            },
            trueParam:true,
            message:null
        }
    },
    computed:{
        
        titleLabel(){
            if(this.isAdd){return "Add " + this.typeName}
            else{ return "Update " + this.currentType.name  }
        },
        titleLabel_short(){
            if(this.isAdd){return "Add"}
            else{ return "Update"  }
        }
    },
    mounted(){
        
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
      
        startAdd(){
            this.message=null
           if(this.isAdd){
                this.currentType={
                    id:0,
                    name:null,
                    isActive:false
                }
            }else{
                this.currentType = JSON.parse(JSON.stringify(this.inType)) 
            }
            

            this.$refs.mymodal.openModal()
        },
        async save(){
            if(this.currentType.name==null || this.currentType.name==''){this.message="Please enter a name"; return}
           this.$emit('save',this.currentType)
           this.$refs.mymodal.closeModal()
        },

      
        
       
        
    }
}
</script>

<style>

</style>





























